var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.033,
    height: 60.404,
    viewBox: "0 0 69.033 60.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image_4_",
    "data-name": "image (4)",
    d: "M37.166,20.585a6,6,0,1,0,6-6A6,6,0,0,0,37.166,20.585ZM56.09,55.775H60.4V29.888L43.146,42.831,21.573,25.573,8.629,38.517V55.775H56.09ZM64.719,4H4.315A4.315,4.315,0,0,0,0,8.315V60.09A4.315,4.315,0,0,0,4.315,64.4h60.4a4.315,4.315,0,0,0,4.315-4.315V8.315A4.315,4.315,0,0,0,64.719,4Zm0,56.09H4.315V8.315h60.4Z",
    transform: "translate(0 -4)",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceDefaultImg);
export default __webpack_public_path__ + "static/media/device_default_img.86f40351e28b61395d4ade2a216c141f.svg";
export { ForwardRef as ReactComponent };